import { Toaster as Sonner, type ToasterProps } from "sonner";

import { resolvedTheme, useTheme } from "@/lib/theme";

/** The mini app's toast: a centred pill, colored by outcome. */
const Toaster = (props: ToasterProps) => {
  const theme = useTheme();
  return (
    <Sonner
      theme={resolvedTheme(theme)}
      position="top-center"
      offset={{ top: "0.75rem" }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "flex w-full items-center justify-center gap-2 rounded-lg px-4 py-3 text-center text-sm shadow-sm",
          icon: "hidden",
          default: "bg-card text-card-foreground",
          info: "bg-card text-card-foreground",
          success: "bg-success text-white",
          warning: "bg-warning text-white",
          error: "bg-danger text-white",
          title: "font-medium leading-snug",
          description: "opacity-90",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
